import * as React from "react";
import {cx} from "emotion";

import "./download-delivery.scss";

import {CheckShowPricing} from "@Common/logic/check-show-pricing";
import {cs}               from "@Common/react/chain-services";

import {MoneySpanOld} from "@Xpresso/routes/common/form/money-span/money-span";

import {FileTypeSelector} from "./file-type-selector/file-type-selector";

export const DownloadDelivery = ({fileTypes: fileTypes1, paperPrice, state, eh, domRef}) => cs(
    ({}) => (
        <div className="download-delivery-3d4">
            {!fileTypes1?.length ? (
                <div className={cx("error", eh.css)} ref={domRef.set} xd-qa-type="label" xd-qa-name="No file types available for download">
                    No file types available for download
                </div>
            ) : <>
                <div className="header">
                    <div className="title">
                        File Type
                    </div>
                </div>

                <div className="card">
                    {FileTypeSelector({
                        images: fileTypes.filter((ft) => fileTypes1.includes(ft.name)).map((img) => ({
                            name: img.name,
                            src: img.source,
                            selected: state.value === img.name,
                            onSelect: () => state.onChange(img.name),
                        })),
                    })}

                    {cs(
                        ({}, next) => CheckShowPricing({next}),

                        () => (
                            <div className="header">
                                Subtotal:
                                <div className="padding"/>
                                {MoneySpanOld({
                                    value: paperPrice?.price ?? 0,
                                    alwaysShowDollarSymbol: true,
                                    useFreeLabel: false,
                                })}
                                <div className="money-span">
                                    USD
                                </div>
                            </div>
                        ),
                    )}
                </div>
            </>}
        </div>
    ),
);

const fileTypes = [
    {
        name: "pdf",
        source: require("./pdf.png"),
    },
    {   
        name: "jpg",
        source: require("./jpg-32.png"),
    }
];
